import React, { useState } from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useApi } from '../../hooks';
import { getPlicanteTokenRequest } from '../../api/plicanteApi';

export default function AdminWasteCadastrePage() {
  const [token, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useApi({setter: (response) => {
      if (response?.data.token) {
        setToken(response.data.token);
          } else {
              setError('Token not found in response');
          }},
    setIsLoading,
    shouldRequest: true,
    request: getPlicanteTokenRequest,
    onError: (error) => {
          setError(error.message || 'Failed to fetch token');
      }
  });
  if (error) {
      return (
          <Box sx={{p: 2}}>
              <Alert severity="error">
                  Error loading token: {error}
              </Alert>
          </Box>
      );
  }

  if (isLoading || !token) {
    return (
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', height: '100%', pt: 3 }}>
      <Box
        sx={{ width: '100%', height: '100%' }}
        component="iframe"
        title="waste_cadastre"
        src={`http://109.120.183.63:8280/operator-ui/?aistoken=${encodeURIComponent('Bearer ' + token)}`}
      />
    </Box>
  );
}